import {
  getLogisticsList,
  updateLogisticsInfo,
  getLogisticsLogList,
  getLogisticsImageType,
  arriveLogisticsInfo,
  getOutboundOrder,
  getOutboundOrderDetail,
  getOutboundOrderCount,
  getInspection,
  getSelectedPurchases,
  getLogisticsTransportTypeList,
  getLogisticsCompanyList,
  addLogisticsOrder,
  getLogisticsListCount,
  getLogisticsInfo,
  getDeliverConsigneeImg,
  inspection,
  getDriverNoHome,
  getDriverToHome,
  getConsigneeResult
} from '@/api/warehouseClerk'
import { Notify } from 'vant'
import { getToken, setToken } from '@/utils/auth'

const state = {
  token: getToken()
}
const mutations = {
  SET_TOEKN(state, token) {
    state.token = token
  }
}
const actions = {
  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('weixin/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      commit('SET_TOEKN', token)
      setToken(token)
      return token
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      commit('SET_TOEKN', '')
      throw error
    }
  },
  // 08-获取物流单列表
  getLogisticsList(temp, data) {
    return new Promise((resolve, reject) => {
      getLogisticsList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 05-更新物流单物流信息
  updateLogisticsInfo(temp, data) {
    return new Promise((resolve, reject) => {
      updateLogisticsInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 04-获取物流单物流历史记录
  getLogisticsLogList(temp, data) {
    return new Promise((resolve, reject) => {
      getLogisticsLogList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getLogisticsImageType(temp, data) {
    return new Promise((resolve, reject) => {
      getLogisticsImageType(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  arriveLogisticsInfo(temp, data) {
    return new Promise((resolve, reject) => {
      arriveLogisticsInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOutboundOrder(temp, data) {
    return new Promise((resolve, reject) => {
      getOutboundOrder(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOutboundOrderDetail(temp, data) {
    return new Promise((resolve, reject) => {
      getOutboundOrderDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOutboundOrderCount(temp, data) {
    return new Promise((resolve, reject) => {
      getOutboundOrderCount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getInspection(temp, data) {
    return new Promise((resolve, reject) => {
      getInspection(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getSelectedPurchases(temp, data) {
    return new Promise((resolve, reject) => {
      getSelectedPurchases(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getLogisticsTransportTypeList(temp, data) {
    return new Promise((resolve, reject) => {
      getLogisticsTransportTypeList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getLogisticsCompanyList(temp, data) {
    return new Promise((resolve, reject) => {
      getLogisticsCompanyList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addLogisticsOrder(temp, data) {
    return new Promise((resolve, reject) => {
      addLogisticsOrder(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getLogisticsListCount(temp, data) {
    return new Promise((resolve, reject) => {
      getLogisticsListCount(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getLogisticsInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getLogisticsInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDeliverConsigneeImg(temp, data) {
    return new Promise((resolve, reject) => {
      getDeliverConsigneeImg(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  inspection(temp, data) {
    return new Promise((resolve, reject) => {
      inspection(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDriverNoHome(temp, data) {
    return new Promise((resolve, reject) => {
      getDriverNoHome(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDriverToHome(temp, data) {
    return new Promise((resolve, reject) => {
      getDriverToHome(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getConsigneeResult(temp, data) {
    return new Promise((resolve, reject) => {
      getConsigneeResult(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
